export default __webpack_public_path__ + "static/media/card3.c409a26b.png";